import { X, Loader2, Send } from 'lucide-react';

export function AskBirdiePanel({
  showAskBirdie,
  setShowAskBirdie,
  askBirdieMessages,
  askBirdieInput,
  setAskBirdieInput,
  askBirdieLoading,
  questionsRemaining,
  sendMessage,
  getSuggestedQuestions,
  isReady = true,
}) {
  if (!showAskBirdie) return null;

  return (
    <>
      {/* Mobile backdrop overlay */}
      <div
        className="fixed inset-0 bg-black/60 z-40 sm:hidden"
        onClick={() => setShowAskBirdie(false)}
      />

      <div className="fixed inset-y-0 right-0 w-full sm:w-[92%] max-w-[450px] bg-slate-900 border-l border-white/10 z-50 flex flex-col shadow-2xl safe-area-inset">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-white/10 bg-gradient-to-r from-purple-500/10 to-pink-500/10">
          <div className="flex items-center gap-3">
            <img src="/logo-bird.png" alt="Birdie" className="h-10 w-10 rounded-full" />
            <div>
              <h3 className="font-bold text-white">Ask Birdie</h3>
              <p className="text-xs text-slate-400">{questionsRemaining} questions remaining</p>
            </div>
          </div>
          <button
            onClick={() => setShowAskBirdie(false)}
            className="text-slate-400 hover:text-white p-3 -mr-1 rounded-lg hover:bg-white/5 min-w-[44px] min-h-[44px] flex items-center justify-center"
            aria-label="Close panel"
          >
            <X className="h-6 w-6" />
          </button>
        </div>

      {/* Suggested Questions */}
      {askBirdieMessages.length === 0 && (
        <div className="p-4 border-b border-white/10">
          <p className="text-xs text-slate-400 mb-3">Suggested questions:</p>
          <div className="flex flex-wrap gap-2">
            {getSuggestedQuestions().map((question, idx) => (
              <button
                key={idx}
                onClick={() => setAskBirdieInput(question)}
                className="text-xs bg-white/5 hover:bg-white/10 border border-white/10 rounded-lg px-3 py-2 text-slate-300 text-left transition"
              >
                {question}
              </button>
            ))}
          </div>
        </div>
      )}

      {/* Messages */}
      <div className="flex-1 overflow-y-auto p-4 space-y-4">
        {askBirdieMessages.map((msg, idx) => (
          <div
            key={idx}
            className={`flex ${msg.role === 'user' ? 'justify-end' : 'justify-start'}`}
          >
            <div
              className={`max-w-[80%] sm:max-w-[85%] rounded-2xl px-4 py-3 ${
                msg.role === 'user'
                  ? 'bg-emerald-500 text-white'
                  : 'bg-white/5 border border-white/10 text-slate-200'
              }`}
            >
              <p className="text-sm whitespace-pre-wrap">{msg.message}</p>
            </div>
          </div>
        ))}
        {askBirdieLoading && (
          <div className="flex justify-start">
            <div className="bg-white/5 border border-white/10 rounded-2xl px-4 py-3">
              <Loader2 className="h-5 w-5 animate-spin text-purple-400" />
            </div>
          </div>
        )}
      </div>

      {/* Input */}
      <div className="p-4 border-t border-white/10 bg-black/50">
        {!isReady ? (
          <div className="text-center py-2">
            <p className="text-slate-400 text-sm">Complete a swing analysis to chat with Birdie.</p>
          </div>
        ) : questionsRemaining > 0 ? (
          <div className="flex gap-2">
            <input
              type="text"
              value={askBirdieInput}
              onChange={(e) => setAskBirdieInput(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && !askBirdieLoading && sendMessage()}
              placeholder="Ask Birdie a question..."
              className="flex-1 bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white placeholder-slate-500 focus:outline-none focus:border-purple-500 text-base"
              style={{ fontSize: '16px' }}
            />
            <button
              onClick={sendMessage}
              disabled={!askBirdieInput.trim() || askBirdieLoading}
              className="bg-gradient-to-r from-purple-500 to-pink-500 rounded-xl px-4 py-3 text-white disabled:opacity-50 disabled:cursor-not-allowed hover:scale-105 transition"
            >
              <Send className="h-5 w-5" />
            </button>
          </div>
        ) : (
          <div className="text-center py-2">
            <p className="text-slate-400 text-sm">You've used all 5 free questions for this analysis.</p>
          </div>
        )}
      </div>
    </div>
    </>
  );
}
